const getDefaultState = () => {
    return {
        notificationType: {},
        notification: {},
        notificationResource: {},
        notificationGroup: {},
        notificationUserSettings: {},
        generalNotificationUserSettings: {},
        notificationUser: {},
        hasUnreadNotifications: false,
    }
}

const state = getDefaultState()

const getters = {
    // NOTIFICATION TYPE
    notificationTypes(state: any) {
        return state.notificationType
    },

    notificationType: (state: any) => (id: string) => {
        return state.notificationType[id]
    },

    // NOTIFICATION
    notifications(state: any) {
        return state.notification
    },

    notification: (state: any) => (id: string) => {
        return state.notification[id]
    },

    // NOTIFICATION RESOURCE
    notificationResources(state: any) {
        return state.notificationResource
    },

    notificationResource: (state: any) => (id: string) => {
        return state.notificationResource[id]
    },

    // NOTIFICATION GROUP
    notificationGroups(state: any) {
        return state.notificationGroup
    },

    notificationGroup: (state: any) => (id: string) => {
        return state.notificationGroup[id]
    },

    // NOTIFICATION USER SETTINGS
    notificationUsersSettings(state: any) {
        return state.notificationUserSettings
    },

    notificationUserSettings: (state: any) => (id: string) => {
        return state.notificationUserSettings[id]
    },

    // GENERAL NOTIFICATION USER SETTINGS
    generalNotificationUserSettings(state: any) {
        return state.generalNotificationUserSettings
    },

    // NOTIFICATION USER
    notificationUsers(state: any) {
        return state.notificationUser
    },

    notificationUser: (state: any) => (id: string) => {
        return state.notificationUser[id]
    },

    // hasNotification
    hasUnreadNotifications(state: any) {
        return state.hasUnreadNotifications
    },
}

const mutations = {
    // NOTIFICATION TYPE
    notificationTypes(state: any, payload: any) {
        state.notificationType = payload
    },

    // NOTIFICATION
    notifications(state: any, payload: any) {
        state.notification = payload
    },

    // NOTIFICATION RESOURCE
    notificationResources(state: any, payload: any) {
        state.notificationResource = payload
    },

    // NOTIFICATION GROUP
    notificationGroups(state: any, payload: any) {
        state.notificationGroup = payload
    },

    // NOTIFICATION USER SETTINGS
    notificationUsersSettings(state: any, payload: any) {
        state.notificationUserSettings = payload
    },

    // GENERAL NOTIFICATION USER SETTINGS
    generalNotificationUserSettings(state: any, payload: any) {
        state.generalNotificationUserSettings = payload
    },

    // NOTIFICATION USER
    notificationUsers(state: any, payload: any) {
        state.notificationUser = payload
    },

    // hasNotification
    hasUnreadNotifications(state: any, payload: any) {
        state.hasUnreadNotifications = payload
    },

    //RESET
    resetNotification(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
